// extracted by mini-css-extract-plugin
module.exports = {"title":"FJPhotoDetails_title__2rcqu","item_container":"FJPhotoDetails_item_container__1RCkn","photo_box":"FJPhotoDetails_photo_box__1gvyw","photo":"FJPhotoDetails_photo__3KjwE"};